// NPM Dependencies
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';

// Config & Constants
import { NEW_BULK_UPLD_EMP, inviteChannelsFields, INDIA_FIELDS_CONSTANT, OTHER_COUNTRIES_FIELDS_CONSTANT, FIELD_TYPES, DELEGATE_TEXTS,
	DATE_FIELD_IDS, TIME_FORMATS, END_OF_DAY_TIME, fnameField, lnameField,
	emailField, mobField, orgField, genderField } from './config';
import { ADOBE_PAGE_NAMES, APPLICATION_CONSTANTS, EMPLOYEE_CONSTANTS } from 'AppConstants';

// Utils
import { pushClickToAdobe } from 'analyticsSdk';
import { getEmployeeList } from 'apis/commonApis';
import { convert24hTo12h } from 'common/Timepicker/utils';

export const formatEmployeeData = (data = [], isAllSelected) => {
	const selectedList = {};
	if (data.length > 0 && isAllSelected) {
		data.forEach((emp) => {
			emp.checked = true;
			selectedList[emp.employeeEmailCommId] = true;
		});
	}
	return {
		list: data,
		selectedList
	};
};

export const handleSelected = (selectedList = {}, payload = {}) => {
	const { items = [], checked } = payload;
	items.forEach((item) => {
		if (checked) {
			item.checked = true;
			selectedList[item.employeeEmailCommId] = true;
		} else {
			item.checked = false;
			delete selectedList[item.employeeEmailCommId];
		}
	});
	return { selectedList: items.length === 0 ? {} : { ...selectedList }, itemList: [...items] };
};

const setOptionsCount = (countData) => (option) => option.count = get(countData, option.countKey);

export const formatFilterCounts = (countData, filters) => {
	let filterData = filters;
	if (countData) {
		const setCount = setOptionsCount(countData);
		filterData = cloneDeep(filters);
		filterData[EMPLOYEE_CONSTANTS.ROLE_KEY].options.forEach(setCount);
		filterData[EMPLOYEE_CONSTANTS.TYPE_KEY].options.forEach(setCount);
		filterData[EMPLOYEE_CONSTANTS.STATE_KEY].options.forEach(setCount);
	}
	return filterData;
};

export const formatFiltersOptions = (filters, filterKey, optionsData) => {
	let filterData = filters;
	if (optionsData) {
		filterData = cloneDeep(filterData);
		filterData[filterKey].options = optionsData;
	}
	return filterData;
};

export const formatManagerData = (employees) => employees.map((employee) => {
	const { businessEmailId, name } = employee;
	return ({
		value: businessEmailId,
		label: name,
		subText: ` (${businessEmailId})`
	});
});

export const formatGroupData = (groups = []) => groups.map((group) => {
	const { groupId, groupName, empCount } = group;
	return ({
		value: groupId,
		label: groupName,
		empCount
	});
});

export const formatDesignationData = (designations) => designations.map((item) => ({
	value: item,
	label: item
}));

const setDropDownQuery = (query, filter, queryValue = []) => {
	const key = filter.key;
	const updatedQuery = cloneDeep(query);
	const updatedFilter = { ...filter };

	if (queryValue && queryValue.length > 0) {
		updatedQuery[key] = queryValue.map((item) => item.value);
	} else {
		updatedQuery[key] && delete updatedQuery[key];
	}
	updatedFilter.showClear = updatedQuery[key] && updatedQuery[key].length > 0;
	return { updatedQuery, updatedFilter };
};

const setCheckboxQuery = (query, filter, queryOption = {}) => {
	const { key, singleSelect = false } = filter;
	const updatedQuery = cloneDeep(query);
	const { checked, value } = queryOption;
	const updatedFilter = { ...filter };

	if (checked) {
		updatedQuery[key] = updatedQuery[key] && Array.isArray(updatedQuery[key]) && !singleSelect ?
			[...updatedQuery[key], value] :
			[value];
	} else {
		updatedQuery[key] = updatedQuery[key].filter((item) => item !== value);
		if (updatedQuery[key].length === 0) delete updatedQuery[key];
	}

	updatedFilter.showClear = (!updatedFilter.hideClear) && updatedQuery[key] && updatedQuery[key].length > 0;
	return { updatedQuery, updatedFilter };
};

export const getFilterQuery = (query, filter = {}, queryData = {}) => {
	const key = filter.key;
	const { value: queryValue, option: queryOption } = queryData;
	switch (key) {
		case EMPLOYEE_CONSTANTS.GROUPS_KEY:
		case EMPLOYEE_CONSTANTS.MANAGER_KEY:
		case EMPLOYEE_CONSTANTS.DESIGNATION_KEY: {
			return setDropDownQuery(query, filter, queryValue);
		}
		case EMPLOYEE_CONSTANTS.ROLE_KEY:
		case EMPLOYEE_CONSTANTS.TYPE_KEY:
		case EMPLOYEE_CONSTANTS.STATE_KEY: {
			return setCheckboxQuery(query, filter, queryOption);
		}
		default: {
			return query;
		}
	}
};

export const clearFilterNQuery = (filters, query, clearedFilter = {}) => {
	const key = clearedFilter.key;
	const updatedQuery = cloneDeep(query);
	const updatedFilters = cloneDeep(filters);
	updatedFilters[key] = { ...clearedFilter, showClear: false };
	updatedQuery[key] && delete updatedQuery[key];

	return {
		updatedQuery,
		updatedFilters
	};
};

export const getUpdatedSortQuery = (sortQuery, sortParam = {}) => {
	const updatedSortQuery = cloneDeep(sortQuery);
	updatedSortQuery.sort = sortParam;
	return updatedSortQuery;
};

export const prefillData = (inputFields = [], modifyData = {}, removableFields ) => {
	const fieldLen = inputFields.length;
	const empName = modifyData.name || '';
	const [fname, ...lname] = empName.split(' ');
	const groupVal = modifyData.groupDetails ? { value: modifyData.groupDetails.groupId, label: modifyData.groupDetails.groupName } :
		{ value: parseInt(APPLICATION_CONSTANTS.ORGANIZATION_LEVEL_GROUP_ID), label: APPLICATION_CONSTANTS.ORGANIZATION_LEVEL_GROUP_NAME };
	const grpId = groupVal.value;
	for (let i = 0; i < fieldLen; i++) {
		switch (inputFields[i].name) {
			case orgField.name:
				inputFields[i].value = inputFields[i].options.length > 0 ?
					inputFields[i].options.filter((grp) => grp.value == grpId)[0] || groupVal : groupVal;
				break;
			case fnameField.name:
				inputFields[i].value = modifyData[fnameField.name] || fname;
				break;
			case genderField.name:
				inputFields[i].value = inputFields[i].options.filter((el) => el.value === modifyData.gender)[0];
				break;
			case lnameField.name:
				inputFields[i].value = modifyData[lnameField.name] || lname?.join(' ');
				break;
			case emailField.name:
				inputFields[i].value = modifyData[emailField.name];
				break;
			case mobField.name:
				inputFields[i].value = modifyData.mobileNo;
				inputFields[i].countryCode = modifyData.countryCode || APPLICATION_CONSTANTS.INDIA_COUNTRY_CODE;
				inputFields[i].maxLen = inputFields[i].countryCode === APPLICATION_CONSTANTS.INDIA_COUNTRY_CODE ?
					INDIA_FIELDS_CONSTANT.maxLen : OTHER_COUNTRIES_FIELDS_CONSTANT.maxLen;
				inputFields[i].validation.custom = inputFields[i].countryCode === APPLICATION_CONSTANTS.INDIA_COUNTRY_CODE ?
					INDIA_FIELDS_CONSTANT.customValidation : OTHER_COUNTRIES_FIELDS_CONSTANT.customValidation;
				break;
			default:
				break;
		}
	}
	const removableLen = removableFields.length;
	const removable = [];
	let removeCount = 0;
	for (let i = 0; i < removableLen; i++) {
		const name = removableFields[i] && removableFields[i].name;
		switch (name) {
			case 'dpt':
			case 'empId':
			case 'cc':
				if (modifyData[name]) {
					removeCount++;
					removableFields[i].set = modifyData[name] ? true : false;
					removableFields[i].value = modifyData[name];
					removableFields[i].set && removable.push(removableFields[i]);
				}

				break;
			default:
				break;
		}
	}
	if (removeCount) {
		inputFields.push({
			name: 'cd',
			label: 'Custom details',
			type: 'label',
			outLabel: true,
			customClass: 'mb0'
		});
	}
	return {
		rCount: removeCount,
		fields: [...inputFields, ...removable],
		updatedRemovable: removableFields
	};
};
export const getReminderSettings = (setting = {}) => ({
	frequency: setting.frequency,
	granular: setting.is_granular,
	granularDay: setting.granular_data.on_day,
	granularPeriod: setting.granular_data.every_period,
	enable: setting.is_enable
});

export const getCsvBulkUploadData = ({ fileData, sendInvitation, invitedId }) => {
	const fileBinary = fileData.fileBlob;
	const sendData = new FormData();
	const alertNewUser = sendInvitation && invitedId === NEW_BULK_UPLD_EMP;
	sendData.append('file', fileBinary);
	sendInvitation && sendData.append('alertNewUserOnly', alertNewUser);
	return sendData;
};

/**
 * formats invitation channel response as per rendering fields data
 * @param {Array} channels
 * @return {Object} fields
 */
export const formatInvitationChannels = (channels = []) => {
	const fields = cloneDeep(inviteChannelsFields);
	channels.map((channel) => {
		let ch = channel.toLowerCase();
		fields[ch].isChecked = true;
	});
	return fields;
};

/**
 * formats invitation Channel data as per api request
 * @param {Object} channelsFieldsConf
 * @return {Object} invitationChannels
 */
export const formatChannelRequest = (channelsFieldsConf) => {
	const channelConfig = Object.values(channelsFieldsConf);
	let channels = [];
	channelConfig && channelConfig.map((channel) => {
		const { isChecked, value } = channel;
		if (isChecked) {
			channels.push(value);
		}
	});
	const invitationChannels = {
		invitationChannels: channels
	};
	return invitationChannels;
};

/**
 * Formatted channels Data as per UI
 * @param {Array} invitationChannels
 * @return {Object}
 */
export const inviteChannelCTA = (invitationChannels) => {
	let inviteBtnCta = 'Invite via ';
	let channelText = 'The invitation to be shared via ';
	if (invitationChannels && invitationChannels.length > 0) {
		let len = invitationChannels.length - 1;
		for (let i = 0; i <= len; i++) {
			inviteBtnCta += ' ' + invitationChannels[i];
			channelText += `<span style=font-weight:700>${invitationChannels[i]}</span>`;
			let seperator = '';
			if (i == len - 1) {
				seperator = ' & ';
			} else if (i != len) {
				seperator = ', ';
			}
			inviteBtnCta += seperator;
			channelText += seperator;
		}
	}
	return { inviteBtnCta, channelText };
};

/**
 * @function pushEmployeeClickToAdobe
 *
 * @author - MMT11933
 * @description - Pushes click event to Adobe analytics SDK
 *
 * @param {string} eventValue - The value of the event
 * @param {object} extraOptions - The extra options for the event
 */
export const pushEmployeeClickToAdobe = (eventValue, extraOptions = {}) => {
	pushClickToAdobe(ADOBE_PAGE_NAMES.EMPLOYEE, eventValue, extraOptions);
};

/**
 * @function formatTimestampToDateParts
 *
 * @author MMT11933
 * @description Formats a timestamp into date parts
 * @param {number} timestamp - The timestamp in milliseconds
 * @return {Object} - Object containing dayOfWeek, month, day, and time
 */
export const formatTimestampToDateParts = (timestamp) => {
	const date = new Date(timestamp);
	const dayOfWeek = date.toLocaleDateString('en-US', { weekday: 'short' });
	const month = date.toLocaleDateString('en-US', { month: 'short' });
	const day = date.getDate();
	const time = date.toLocaleTimeString('en-US', {
		hour: 'numeric',
		minute: '2-digit',
		hour12: true
	});

	return { dayOfWeek, month, day, time };
};

/**
 * @function convertDateAndTimeToEpoch
 *
 * @author - MMT11933
 * @description - Converts date and time objects to epoch timestamp
 * @param {Date|null} date - The date object
 * @param {Object|null} time - The time object with { hour, minute, period }
 * @param {string} fieldId - Optional field ID to determine default time (e.g., 'startDate' uses 00:00:00, 'endDate' uses 23:59:59)
 * @return {number|null} - Epoch timestamp in milliseconds, or null if date is missing
 */
export const convertDateAndTimeToEpoch = (date, time, fieldId = null) => {
	if (!date) {
		return null;
	}

	const dateObj = new Date(date);

	// If time is provided and valid, use it
	if (time && time.hour !== undefined && time.minute !== undefined) {
		dateObj.setHours(time.hour || 0, time.minute || 0, 0, 0);
	} else if (fieldId === DATE_FIELD_IDS.END_DATE) {
		// For endDate, use end of day (23:59:59.999) when time is not provided
		dateObj.setHours(END_OF_DAY_TIME.HOUR_24H, END_OF_DAY_TIME.MINUTE, END_OF_DAY_TIME.SECONDS, END_OF_DAY_TIME.MILLISECONDS);
	} else {
		// Default to start of day (00:00:00) for startDate or unknown fields
		dateObj.setHours(0, 0, 0, 0);
	}

	return dateObj.getTime();
};

/**
 * @function convertEpochToDateAndTime
 *
 * @author - MMT11933
 * @description - Converts epoch timestamp to date and time objects
 * @param {number|null} epoch - Epoch timestamp in milliseconds
 * @return {Object} - Object with { date: Date, time: { hour, minute, period } } or { date: null, time: null }
 */
export const convertEpochToDateAndTime = (epoch) => {
	if (!epoch || typeof epoch !== 'number') {
		return { date: null, time: null };
	}

	const dateObj = new Date(epoch);
	return {
		date: dateObj,
		time: {
			hour: dateObj.getHours(),
			minute: dateObj.getMinutes(),
			period: 'AM' // Default, TimePicker will handle 12h/24h format
		}
	};
};

/**
 * @function convertInitialValueForDateRange
 *
 * @author - MMT11933
 * @description - Converts epoch values to date/time objects for date range fields
 * @param {string} fieldType - The type of field
 * @param {Object|null} value - The initial value object
 * @return {Object|null} - Converted value object or original value
 */
export const convertInitialValueForDateRange = (fieldType, value) => {
	if (fieldType === FIELD_TYPES.DATE_TIME_RANGE_FLD && value) {
		const convertedValue = {};
		Object.keys(value).forEach((key) => {
			const val = value[key];
			// If value is a number (epoch), convert it to date/time object
			if (typeof val === 'number') {
				convertedValue[key] = convertEpochToDateAndTime(val);
			} else {
				convertedValue[key] = val;
			}
		});
		return convertedValue;
	}
	return value;
};

/**
 * @function loadEmpSuggestions
 *
 * @author - MMT11933
 * @description - Fetches employee suggestions and transforms them to Autosuggest format
 * @param {string} query - Search query string
 * @return {Promise<Array>} - Transformed employee options array
 */
export const loadEmpSuggestions = async (query) => {
	try {
		const response = await getEmployeeList(query);
		if (!response || response === false) {
			return [];
		}

		return response.map((employee) => ({
			name: employee?.name || employee?.businessEmailId || '',
			email: employee?.businessEmailId || employee?.id || employee?.value || '',
			...employee
		}));
	} catch (error) {
		return [];
	}
};

/**
 * @function isFormValid
 *
 * @author - MMT11933
 * @description - Validates if all required form fields are filled
 * @param {Object} formData - The form data object to validate
 * @return {boolean} - True if form is valid, false otherwise
 */
export const isFormValid = (formData) => {
	// Check delegates - should have selectedOption with email or businessEmailId (internal format)
	const delegates = formData.delegates;
	if (!delegates || typeof delegates !== 'object' || Array.isArray(delegates)) {
		return false;
	}
	if (!delegates.selectedOption) {
		return false;
	}
	// Check for either email or businessEmailId property
	const emailId = delegates.selectedOption.businessEmailId || delegates.selectedOption.email;
	if (!emailId || typeof emailId !== 'string' || emailId.trim() === '') {
		return false;
	}

	// Check reasonForDelegation - must have a non-empty value
	const reasonForDelegation = formData.reasonForDelegation;
	if (!reasonForDelegation || typeof reasonForDelegation !== 'string' || reasonForDelegation.trim() === '') {
		return false;
	}

	// Check notificationType - must have a value (can be object with value property or string)
	const notificationType = formData.notificationType;
	if (!notificationType) {
		return false;
	}
	const notificationValue = typeof notificationType === 'object' && notificationType !== null ?
		notificationType.value :
		notificationType;
	if (!notificationValue || (typeof notificationValue === 'string' && notificationValue.trim() === '')) {
		return false;
	}

	// Check date fields based on isPermanentDelegate
	if (!formData.isPermanentDelegate) {
		// If not permanent, both startDate and endDate are required (must have date property)
		const startDate = formData.startDate;
		const endDate = formData.endDate;
		if (!startDate || typeof startDate !== 'object' || !startDate.date) {
			return false;
		}
		if (!endDate || typeof endDate !== 'object' || !endDate.date) {
			return false;
		}
	}
	// If isPermanentDelegate is true, dates are not required

	return true;
};

/**
 * @function convertDelegatesToInternalFormat
 *
 * @author - MMT11933
 * @description - Converts delegates array format to internal autosuggest format
 * @param {Array} value - The delegates array
 * @return {Object} - Internal format with selectedOption and inputValue
 */
export const convertDelegatesToInternalFormat = (value) => {
	if (!value || !Array.isArray(value) || value.length === 0) {
		return { selectedOption: null, inputValue: '' };
	}
	const primaryDelegate = value.find((d) => d.order === 'primary');
	if (primaryDelegate && primaryDelegate.delegateEmailId) {
		return {
			selectedOption: { businessEmailId: primaryDelegate.delegateEmailId },
			inputValue: ''
		};
	}
	return { selectedOption: null, inputValue: '' };
};

/**
 * @function convertInitialValueForField
 *
 * @author - MMT11933
 * @description - Converts initial value based on field type (delegates, date/time, etc.)
 * @param {string} fieldType - The type of field
 * @param {any} value - The initial value to convert
 * @param {Object} formData - Optional formData object to construct date time range when value is undefined
 * @return {any} - Converted value
 */
export const convertInitialValueForField = (fieldType, value, formData = null) => {
	// For date time range field, construct value from formData if value is undefined
	if (fieldType === FIELD_TYPES.DATE_TIME_RANGE_FLD) {
		if (value === undefined && formData) {
			return {
				startDate: formData.startDate || { date: null, time: null },
				endDate: formData.endDate || { date: null, time: null }
			};
		}
		if (value && typeof value === 'object' && (value.startDate || value.endDate)) {
			// Check if startDate/endDate are numbers (epoch) - need conversion
			if (typeof value.startDate === 'number' || typeof value.endDate === 'number') {
				return convertInitialValueForDateRange(fieldType, value);
			}
			// Already in internal format, return as-is
			return value;
		}
		return value;
	}
	// For autosuggest field, if value is array (old format), convert to internal format
	if (fieldType === FIELD_TYPES.AUTOSUGGEST_FLD && Array.isArray(value)) {
		return convertDelegatesToInternalFormat(value);
	}
	// Already in internal format or other types, return as-is
	return value;
};

/**
 * @function convertInternalFormatToApiFormat
 *
 * @author - MMT11933
 * @description - Converts internal field formats to API format
 * @param {Object} formData - The form data in internal format
 * @return {Object} - Form data in API format
 */
const convertInternalFormatToApiFormat = (formData) => {
	const apiData = { ...formData };

	// Convert delegates from internal format { selectedOption, inputValue } to array format
	if (apiData.delegates && typeof apiData.delegates === 'object' && !Array.isArray(apiData.delegates)) {
		if (apiData.delegates.selectedOption?.email) {
			apiData.delegates = [{ delegateEmailId: apiData.delegates.selectedOption.email, order: 'PRIMARY' }];
		} else {
			apiData.delegates = [];
		}
	}

	// Convert date/time objects to epoch timestamps
	if (apiData.startDate && typeof apiData.startDate === 'object' && apiData.startDate.date) {
		apiData.startDate = convertDateAndTimeToEpoch(apiData.startDate.date, apiData.startDate.time, 'startDate');
	}
	if (apiData.endDate && typeof apiData.endDate === 'object' && apiData.endDate.date) {
		apiData.endDate = convertDateAndTimeToEpoch(apiData.endDate.date, apiData.endDate.time, 'endDate');
	}

	return apiData;
};

/**
 * @function prepareFormDataForApi
 *
 * @author - MMT11933
 * @description - Prepares form data for API submission by converting internal formats to API format
 * and removing date fields if isPermanentDelegate is true
 * @param {Object} formData - The form data object in internal format
 * @return {Object} - Form data ready for API submission
 */
export const prepareFormDataForApi = (formData) => {
	// Convert internal formats to API format
	const apiData = convertInternalFormatToApiFormat(formData);

	// If isPermanentDelegate is true, remove startDate and endDate from the payload
	if (apiData.isPermanentDelegate) {
		delete apiData.startDate;
		delete apiData.endDate;
	}

	return apiData;
};

/**
 * @function calculateMinDateForEndDate
 *
 * @author - MMT11933
 * @description - Calculates the minimum date for endDate field based on startDate and today
 * @param {string} fieldStatePath - The state path of the field ('startDate' or 'endDate')
 * @param {Object} startDateValue - The startDate value object with { date, time }
 * @param {Date} today - Today's date normalized to midnight
 * @return {Date} - The minimum date to use for the calendar
 */
export const calculateMinDateForEndDate = (fieldStatePath, startDateValue, today) => {
	if (fieldStatePath === DATE_FIELD_IDS.END_DATE && startDateValue?.date) {
		const startDate = startDateValue.date instanceof Date ?
			new Date(startDateValue.date.getTime()) :
			new Date(startDateValue.date);
		startDate.setHours(0, 0, 0, 0);
		return startDate.getTime() > today.getTime() ? startDate : today;
	}
	return today;
};

/**
 * @function isToday
 *
 * @author - MMT11933
 * @description - Checks if a given date is today
 * @param {Date} date - The date to check
 * @param {Date} today - Today's date (normalized to start of day)
 * @return {boolean} - True if the date is today
 */
export const isToday = (date, today) => {
	if (!date) return false;
	const checkDate = new Date(date);
	checkDate.setHours(0, 0, 0, 0);
	return checkDate.getTime() === today.getTime();
};

/**
 * @function getCurrentTime
 *
 * @author - MMT11933
 * @description - Gets current time in the format expected by TimePicker
 * @param {string} format - Time format ('24h' or '12h')
 * @return {Object} - Time object with hour, minute, and optional period
 */
export const getCurrentTime = (format = TIME_FORMATS.FORMAT_24H) => {
	const now = new Date();
	const hour24 = now.getHours();
	const minute = now.getMinutes();

	if (format === TIME_FORMATS.FORMAT_12H) {
		const { hour, period } = convert24hTo12h(hour24);
		return { hour, minute, period };
	}
	return { hour: hour24, minute };
};

/**
 * @function getEndOfDayTime
 *
 * @author - MMT11933
 * @description - Gets 23:59 time in the format expected by TimePicker
 * @param {string} format - Time format ('24h' or '12h')
 * @return {Object} - Time object with hour, minute, and optional period
 */
export const getEndOfDayTime = (format = TIME_FORMATS.FORMAT_24H) => {
	if (format === TIME_FORMATS.FORMAT_12H) {
		return { hour: END_OF_DAY_TIME.HOUR_12H, minute: END_OF_DAY_TIME.MINUTE, period: END_OF_DAY_TIME.PERIOD };
	}
	return { hour: END_OF_DAY_TIME.HOUR_24H, minute: END_OF_DAY_TIME.MINUTE };
};

/**
 * @function extractRadioFieldValue
 *
 * @author - MMT11933
 * @description - Extracts string value from radio field value (handles both string and object formats)
 * @param {string|Object} fieldValue - The field value (can be string or object with value property)
 * @return {string} - The extracted string value
 */
export const extractRadioFieldValue = (fieldValue) => typeof fieldValue === 'string' ? fieldValue : (fieldValue?.value || '');

/**
 * @function findMatchingRadioOption
 *
 * @author - MMT11933
 * @description - Finds the matching option object from options array based on value comparison
 * @param {string} currentValueStr - The current value string to match
 * @param {Array} options - Array of option objects
 * @return {Object|null} - The matching option object or null
 */
export const findMatchingRadioOption = (currentValueStr, options) => {
	if (!currentValueStr || !options || !Array.isArray(options)) {
		return null;
	}
	return options.find((opt) => String(opt.value) === String(currentValueStr)) || null;
};

/**
 * @function prepareRadioOptionsWithChecked
 *
 * @author - MMT11933
 * @description - Maps options array and marks the matching option as checked
 * @param {Array} options - Array of option objects
 * @param {string} currentValueStr - The current value string to match
 * @return {Array} - Array of options with isChecked property set
 */
export const prepareRadioOptionsWithChecked = (options, currentValueStr) => {
	if (!options || !Array.isArray(options)) {
		return [];
	}
	return options.map((option) => ({
		...option,
		isChecked: String(option.value) === String(currentValueStr)
	}));
};

/**
 * @function handleFormFieldChangeLogic
 *
 * @author - MMT11933
 * @description - Handles form field change logic based on field type and subpath
 * @param {Object} params - Parameters object
 * @return {Object|null} - Returns update instruction object or null if handled internally
 */
export const handleFormFieldChangeLogic = (params) => {
	const { fieldId, fieldType, value, subPath, options, updateFieldValue, onChange, isInternalUpdateRef, currentValue } = params;

	switch (fieldType) {
		case FIELD_TYPES.AUTOSUGGEST_FLD: {
			switch (subPath) {
				case 'select':
					updateFieldValue({ selectedOption: value, inputValue: '' });
					return null;
				case 'unselect':
					updateFieldValue({ selectedOption: null, inputValue: '' });
					return null;
				case 'inputValue':
					if (typeof value === 'string') {
						return {
							fieldType: FIELD_TYPES.AUTOSUGGEST_FLD,
							subPath: 'inputValue',
							value,
							currentValue
						};
					}
					return null;
				default:
					return null;
			}
		}
		case FIELD_TYPES.DATE_FLD:
		case FIELD_TYPES.TIME_FLD: {
			if (subPath) {
				return { fieldType, fieldId, subPath, value, currentValue, onChange, isInternalUpdateRef };
			}
			return null;
		}
		case FIELD_TYPES.RADIO_FLD: {
			if (options) {
				const selectedOption = options.find((opt) => opt.value === value);
				if (selectedOption) {
					updateFieldValue(selectedOption.value);
				}
			}
			return null;
		}
		default:
			updateFieldValue(value);
			return null;
	}
};

/**
 * @function formatDelegateAccount
 *
 * @author MMT11933
 * @description Converts API response format to component format
 * @param {Object} delegation - The delegation object from API response
 * @return {Object} - Object containing name, email, startTime, endTime, isPermanent
 */
export const formatDelegateData = (delegation) => {
	const { dayOfWeek, month, day } = formatTimestampToDateParts(delegation?.startDate);
	const { dayOfWeek: endOfWeek, month: endMonth, day: endDay } = formatTimestampToDateParts(delegation?.endDate);

	// Find primary delegate from delegates array
	const primaryDelegate = delegation?.delegates?.find((delegate) => delegate?.order === 'PRIMARY');
	const delegateEmail = primaryDelegate?.delegateEmailId || delegation?.principalEmailId;
	const delegateName = primaryDelegate?.delegateName || delegation?.principalName;
	const isPermanent = delegation?.isPermanentDelegate;

	return {
		delegationId: delegation?.delegationId,
		name: delegateName,
		email: delegateEmail,
		duration: isPermanent ? DELEGATE_TEXTS.PERM_DEL : `${dayOfWeek}, <b>${month} ${day}</b> - ${endOfWeek}, <b>${endMonth} ${endDay}</b>`,
		status: delegation?.delegationStatus,
		isPermanent: isPermanent
	};
};
